var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.topic)?_c('topic-posts',{ref:"posts",attrs:{"topic":_vm.topic,"query":_vm.query,"can-auth-edit":_vm.item.canAuthEdit},on:{"create":function($event){return _vm.posts.refresh()}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }